import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CheckoutService } from 'src/app/services/checkout.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-checkout-tickets-event-modal',
  templateUrl: './checkout-tickets-event-modal.component.html',
  styleUrls: ['./checkout-tickets-event-modal.component.scss'],
})
export class CheckoutTicketsEventModalComponent implements OnInit {
  totalFinal = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CheckoutTicketsEventModalComponent>,
    private spinnerService: SpinnerService,
    private checkoutService: CheckoutService
  ) {}

  ngOnInit() {
    this.data.ticketsBuy.forEach((element: any) => {
      this.totalFinal += element.price * element.quantitie;
    });
  }

  closeDialog(action: any) {
    this.dialogRef.close(action);
  }

  async checkout() {
    this.spinnerService.showSpinner();
    (await this.checkoutService.checkoutAccess(this.data.ticketsBuy)).subscribe(
      (data) => {
        if (data.result) {
          window.location.href = data.result.init_point;
          setTimeout(() => {
            this.spinnerService.hideSpinner();
          }, 2000);
        } else {
          alert('checkoutAccess ' + data.message);
        }
      }
    );
  }
}
